import React from 'react';
import styled from 'styled-components/macro';
import Scroll from 'react-scroll';
import { rgba } from 'polished';
const ScrollLink = Scroll.ScrollLink;

function AZButton(props) {
  return <Button {...props}>{props.children}</Button>;
}

const Button = styled.button`
  background-color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.white90
      : props.theme.color.black90};
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.black90
      : props.theme.color.white90};
  border: 0;
  border-radius: 20px;
  cursor: pointer;
  display: inline-block;
  font-size: 18px;
  padding: 4px 16px;
  backdrop-filter: blur(24px);
  transition: all 0.15s ease-in;
  &:hover {
    background-color: ${(props) =>
      props.theme.name === 'light'
        ? rgba(props.theme.color.blackFull, 0.25)
        : rgba(props.theme.color.whiteFull, 0.25)};
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
  }
  &:focus-visible {
    background-color: ${(props) =>
      props.theme.name === 'light'
        ? rgba(props.theme.color.blackFull, 0.25)
        : rgba(props.theme.color.whiteFull, 0.25)};
    box-shadow: 0px 0px 0px 2px
      ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.statusLightFocus
          : props.theme.color.statusDarkFocus};
    border-radius: 20px;
    outline: none;
  }
`;

export default ScrollLink(AZButton);
